import { getPassRateColor } from "@repo/app-types/constants/passRate";
import type { Size } from "@repo/ui/helpers/helpers";
import { getPillColor } from "@repo/ui/Pills/pill";
import type { FC } from "react";
import { customerExperienceScoreToPercent } from "../topics/topicStatsFormatters.js";
import { PercentagePill } from "./percentagePill.js";

export interface CustomerExperienceScorePercentPillProps {
  size: Size;
  /**
   * The raw 1-5 score. `undefined` renders as a muted `--` (absent number);
   * `null` renders as an "N/A" pill (metric inapplicable).
   */
  score: number | null | undefined;
  isLoading?: boolean;
  onClick?: () => void;
}

/**
 * Pill rendering a customer-experience score as a 0-100 percentage.
 * Maps the raw 1-5 value onto a 0-100 display scale and colors the
 * pill using the same banding as `GradingPassRatePill` (≥90 emerald,
 * ≥80 green, ≥70 lime, ≥60 amber, ≥50 orange, <50 red). Used on the
 * team page to display per-teammate averages. The per-grading
 * (integer + label) variant lives in
 * `gradingCustomerExperienceScorePill.tsx`.
 */
export const CustomerExperienceScorePercentPill: FC<
  CustomerExperienceScorePercentPillProps
> = (props) => (
  <PercentagePill
    size={props.size}
    value={
      typeof props.score === "number"
        ? customerExperienceScoreToPercent(props.score)
        : props.score
    }
    isLoading={props.isLoading}
    computeColor={(value) => getPillColor(getPassRateColor(value / 100))}
    renderPercentage={(value) => `${Math.round(value)}`}
    onClick={props.onClick}
  />
);
